import GlobalAntButton from 'modules/Common/Components/GlobalAntButton';
import DoubleCheckIcon from 'assets/svgs/DoubleCheckIcon';
import styled from 'styled-components';

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  height: 84px;
  border: 1px solid #e7e7e7;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .delete-wrapper {
    padding-left: 102px;
    display: flex;
    align-items: center;
    @media all and (min-height: 729px) {
      padding-left: 129px !important;
    }
  }
  .selected-items {
    color: #7e7e7e;
    font-family: 'Roboto';
    font-size: 18.004px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-left: 14px;
  }
  .clear-selection {
    color: #1ec252;
    font-family: 'Roboto';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.3px;
    padding-left: 12px;
    :hover {
      cursor: pointer;
    }
  }
`;

const CreateFormFooter = ({
  onClick,
  onClickClearSelection,
  disableButton,
  btnText,
  footerType = 'default',
  selectedFormIds,
  selectAll,
  excludedFormIds,
  totalForms,
}: {
  onClick: () => void;
  onClickClearSelection?: () => void;
  disableButton: boolean;
  btnText: string;
  footerType: string;
  selectedFormIds?: number[];
  selectAll?: boolean;
  excludedFormIds?: number[];
  totalForms?: number;
}) => {
  const disabled = false;
  const DeleteFooter = () => (
    <>
      <div className="delete-wrapper">
        <DoubleCheckIcon />
        <span className="selected-items">
          {selectAll && totalForms && excludedFormIds ? totalForms - excludedFormIds?.length : selectedFormIds?.length} Selected
        </span>
        <span className="clear-selection" onClick={onClickClearSelection}>
          Clear selection
        </span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'end', marginRight: '62px', alignItems: 'center', height: '100%', color: 'white' }}>
        <GlobalAntButton
          btnText={btnText}
          icon={''}
          buttonType={'type'}
          btnType={'default'}
          disabled={disableButton}
          loading={false}
          onClick={onClick}
          border={' 1px solid #7E7E7E'}
          padding={'8px 17px'}
          bgColor={`${disabled ? 'rgb(126 126 126 / 42%)' : '#fff'}`}
          color={'#7E7E7E'}
          customIcon={''}
          borderRadius={'20px'}
          fontSize={'16px'}
          boxShadow={''}
          maxWidth={''}
          width={'84px'}
        />
      </div>
    </>
  );
  return (
    <FooterWrapper>
      {footerType === 'default' ? (
        <div
          style={{ display: 'flex', justifyContent: 'end', marginRight: '62px', alignItems: 'center', height: '100%', width: '100%', color: 'white' }}
        >
          <GlobalAntButton
            btnText={btnText}
            icon={''}
            buttonType={'type'}
            btnType={'default'}
            disabled={disableButton}
            loading={false}
            onClick={onClick}
            border={''}
            padding={'0 18px'}
            bgColor={`${disabled ? '#80E494' : '#1EC252'}`}
            color={'#fff'}
            customIcon={''}
            borderRadius={'20px'}
            fontSize={'16px'}
            boxShadow={''}
            maxWidth={''}
            width={''}
          />
        </div>
      ) : footerType === 'delete' ? (
        <DeleteFooter />
      ) : (
        ''
      )}
    </FooterWrapper>
  );
};

export default CreateFormFooter;
